<div class="container-fluid" style="max-height: 50vh;">
  <div class="row">

    <div class="col-sm-11 text-center" >
      <p style="font-weight: bold;">Notes</p>
      <form (ngSubmit)="onSubmitTextArea()" #f="ngForm" >

        <div class="col-sm-12=" style="margin: solid black;">
          <mat-form-field class="system-note" appearance="fill">
            <mat-label>Write note here ...</mat-label>
            <textarea matInput name="notes" id="notes" [(ngModel)]="insertedNoteText"
              #notes="ngModel" autocomplete="off"
              cdkTextareaAutosize cdkAutosizeMinRows="10" cdkAutosizeMaxRows="100">
            </textarea>
          </mat-form-field>
        </div>

        <div class="col-sm-12">
          <button mat-raised-button  color="primary" style="margin-right: 5px;"
          type="submit" [disabled]="!f.valid">Confirm</button>
        </div>

      </form>
    </div>

    <div id="closeBtn" style="margin: 0px;padding: 0px;display: inline-block;position: relative;right: 5px;">
      <mat-icon aria-hidden="false" class="fa-2x"  style="width: 100%; color: grey; position: absolute;right: 5px;"
        id="closeBtn" (click)="onNoClick()">close</mat-icon>
    </div>

  </div>
</div>


